<template>
  <badge :type="getBadgeType()">{{
    $t('TRANSACTIONS_DPA.' + data.status)
  }}</badge>
</template>

<script>
import {
  paymentStatusesOption,
  PAYMENT_STATUS_CANCELED,
  PAYMENT_STATUS_COMPLETED,
  PAYMENT_STATUS_DRAFT,
  PAYMENT_STATUS_PENDING,
  PAYMENT_STATUS_AWAITING_SIGNATURE,
  PAYMENT_STATUS_SIGNATURE_DELINED
} from "@/constants/payments";
import { 
  STATUS_DRAFT,
  STATUS_PENDING,
  STATUS_SENT,
  STATUS_SENT_TO_BANK,
  STATUS_REFUSED,
  STATUS_COMPLETED,
  STATUS_HOLDON
} from "@/constants/transactions";

export default {
  name: "transaction-status-badge",

  components: {},

  mixins: [],

  props: ["data"],

  data() {
    return {
      statusesOptions: paymentStatusesOption,
    };
  },

  computed: {},

  methods: {
    getBadgeType() {
      switch (this.data.status) {
        case STATUS_DRAFT:
          return "primary";
        case PAYMENT_STATUS_PENDING:
          return "warning";
        case PAYMENT_STATUS_COMPLETED:
          return "success";
        case STATUS_REFUSED:
          return "danger";
        default:
          break;
      }
      return "default";
    },
  },

  mounted() {},

  watch: {},
};
</script>
